import { useEffect, useState } from 'react'

import type { BillLocationValue } from '@/constants/bill-location'
import { useDefaultLocation } from '@/hooks/useDefaultLocation'
import {
  parseLocationSearchParam,
  type OptionalBillLocation,
} from '@/utils/bill-location-preference'

export function useInitialLocationFilter(): [
  OptionalBillLocation,
  (value: OptionalBillLocation) => void,
  { isLoading: boolean },
] {
  const { defaultLocation, isLoading } = useDefaultLocation()
  const [location, setLocation] = useState<OptionalBillLocation>('')
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (initialized || isLoading) return
    if (defaultLocation) {
      setLocation(defaultLocation)
    }
    setInitialized(true)
  }, [defaultLocation, initialized, isLoading])

  return [location, setLocation, { isLoading }]
}

export function useInitialRequiredLocation(
  searchParam?: string,
): [BillLocationValue, (value: BillLocationValue) => void, { isLoading: boolean }] {
  const { defaultLocation, isLoading } = useDefaultLocation()
  const [location, setLocation] = useState<BillLocationValue>(() =>
    parseLocationSearchParam(searchParam),
  )
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (initialized || isLoading) return
    if (!searchParam && defaultLocation) {
      setLocation(defaultLocation)
    }
    setInitialized(true)
  }, [defaultLocation, initialized, isLoading, searchParam])

  return [location, setLocation, { isLoading }]
}
